import CreateGmail from "./smtp/CreateGmail";
import CreateOutlook from "./smtp/CreateOutlook";
import CreateSMTP from "./smtp/CreateSMTP";
import CreateMassMailing from "./smtp/CreateMassMailing";
import { Divider } from "@mantine/core";
import { useSessionStore } from "../../../../stores/UserStore";

const CreateDropdown = ({ setTableLoading, inPool }) => {
  const reseller = useSessionStore((s) => s.reseller);
  return (
    <>
      {((reseller?.name !== "Magileads" &&
        reseller?.options.find((x) => x.name === "ShowSmtpConnectionGmail")
          ?.active) ||
        reseller?.name === "Magileads") && (
        <CreateGmail setTableLoading={setTableLoading} />
      )}

      {((reseller?.name !== "Magileads" &&
        reseller?.options.find((x) => x.name === "ShowSmtpConnectionOutlook")
          ?.active) ||
        reseller?.name === "Magileads") && (
        <CreateOutlook setTableLoading={setTableLoading} />
      )}
      <CreateSMTP />
      {!inPool && (
        <>
          <Divider my={8} /> <CreateMassMailing />{" "}
        </>
      )}
    </>
  );
};

export default CreateDropdown;
